import { render } from "./addStock.vue?vue&type=template&id=ee69fb60"
import script from "./addStock.vue?vue&type=script&lang=js"
export * from "./addStock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__